<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4120_1637)">
      <path
        d="M10.3335 8.64L15.6035 12L10.3335 15.36V8.64ZM8.3335 5V19L19.3335 12L8.3335 5Z"
        fill="#383838"
      />
    </g>
    <defs>
      <clipPath id="clip0_4120_1637">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.333496)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
